module.exports = __webpack_public_path__ + "static/time-block-c7b823929e73e72995dc423602a21eb4.gif";